
const serviceSystem = [
  {
    path: '/service-system',
    name: 'service-system',
    component: () => import('@/views/wxapp/service-system'),
    redirect: '/service-system/list',
    meta: {
      title: '用户服务详情'
    },
    children: [
      {
        path: 'list',
        name: 'service-system-list',
        component: () => import('@/views/wxapp/service-system/list'),
        meta: {
          title: '我的用户'
        }
      },
      {
        path: 'info',
        name: 'service-system-info',
        component: () => import('@/views/wxapp/service-system/info'),
        // redirect: '/service-system/info',
        meta: {
          title: '用户服务详情'
        }
      },
      {
        path: 'decoration-archives',
        name: 'service-system-decoration-archives',
        component: () => import('@/views/wxapp/service-system/decoration-archives'),
        meta: {
          title: '用户装修档案'
        }
      },
      {
        path: 'standard-process-details',
        name: 'service-system-standard-process-details',
        component: () => import('@/views/wxapp/service-system/site-details/tabList/details'),
        meta: {
          title: '标准工艺详情'
        }
      }
    ]
  }
]
export default serviceSystem
